import { ApiResult, caller, urlMaker } from '@shared/utils';
import { ISettings, SettingsApi } from '../interface';
import { SettingsMapper } from '../mappers/settings.mapper';

export class SettingsService {
  static async getSettings(): Promise<ApiResult<200, ISettings> | ApiResult<400 | 500, string>> {
    try {
      const url = urlMaker('/api/client/settings', { office: 1 });
      const response = await caller(url);

      if (response.ok) {
        const { data } = await response.json();
        return new ApiResult(200, SettingsMapper.toDomain(data as SettingsApi), null);
      }

      return new ApiResult(400, 'Operation failed', null);
    } catch {
      return new ApiResult(500, 'Network request failed', null);
    }
  }
}
